import { Component, computed, input, output, signal } from "@angular/core";
import { MatButton } from "@angular/material/button";
import { TranslatePipe } from "@ngx-translate/core";
import { FaIconComponent } from "@fortawesome/angular-fontawesome";
import { faCopy } from "@fortawesome/pro-light-svg-icons";

import { MessageTypes } from "libs/messages/src/lib/models/message.model";
import { isMessageEmpty } from "libs/messages/src/lib/utils/message-format.utils";
import { CommentComponent } from "../comment/comment.component";
import { MessageTypesComponent } from "../message-types/message-types.component";

export interface CustomerSubmitMessageEvent {
	message: string;
	messageType: MessageTypes;
}

@Component({
	selector: "lib-message-editor",
	templateUrl: "./message-editor.component.html",
	styleUrls: ["./message-editor.component.scss"],
	imports: [CommentComponent, MatButton, TranslatePipe, MessageTypesComponent, FaIconComponent],
})
export class MessageEditorComponent {
	readonly showHeader = input<boolean>(true);
	readonly showMessageTypeSelection = input<boolean>(true);

	readonly submitMessage = output<CustomerSubmitMessageEvent>();

	protected readonly messageType = signal<MessageTypes>(MessageTypes.Note);
	protected readonly message = signal<string>("");
	protected readonly faCopy = faCopy;
	protected readonly isSendButtonDisabled = computed(() => isMessageEmpty(this.message()));

	onMessageChange(value: string) {
		this.message.set(value);
	}

	onNewMessageType(type: MessageTypes) {
		this.messageType.set(type);
	}

	onSubmit() {
		this.submitMessage.emit({
			message: this.message(),
			messageType: this.messageType(),
		});
		this.message.set("");
	}
}
